import Loader from "react-loader-spinner";
import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { CheckLg, ExclamationTriangleFill, PlusCircle, Trash } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { getCityList, getZoneList } from "../../store/api/LocationAPI";
import { getAllProductMainGroups, getProductGroups } from "../../store/api/GetAllProduct";
import { getStaffAutoSendData, updateStaffAutoSendData } from "../../store/api/StaffAPI";
import { setErrorDialog } from "../../../store/api/CommonFunctions";


const AutoSendStaffSettings = (props) => {
    const { staffID } = props;
    const currWG = useRef({});
    const currWL = useRef({});
    const dispatch = useDispatch();
    const [panelIsActive, setPanelActive] = useState(true);
    const [autoSendData, setAutoSendData] = useState({});
    const { cityList, zoneList, provinceList, productMainGroupList, productGroupList } =
        useSelector(state => {
            return {
                cityList: state.locationDataReducer.cityList,
                zoneList: state.locationDataReducer.zoneList,
                provinceList: state.locationDataReducer.provinceList,
                productMainGroupList: state.ProductReducer.productMainGroupList,
                productGroupList: state.ProductReducer.productGroupList
            }
        });
    function loadCityList(provinceID) {
        const province = provinceList.find(p => Number(p.Id) === Number(provinceID))?.Name;
        currWL.current.ProvinceName = province;
        dispatch(getCityList(provinceID));
    }
    function loadZoneList(cityID) {
        const city = cityList.find(c => Number(c.Id) === Number(cityID))?.Name;
        currWL.current.CityName = city;
        dispatch(getZoneList(cityID));
    }
    function loadPGList(mainGID) {
        const mainGName = productMainGroupList.find(m => Number(m.MainGroupID) === Number(mainGID))?.MainGroupName;
        currWG.current.MainGroup = mainGName;
        dispatch(getProductGroups(mainGID));
    }
    function addWGtoList() {
        if (!currWG.current.ProductGroupID || currWG.current.ProductGroupID === "") {
            return;
        }
        const isExists = autoSendData.WorkingGroups && Array.isArray(autoSendData.WorkingGroups) && autoSendData.WorkingGroups.some(w => Number(w.ProductGroupID) === Number(currWG.current.ProductGroupID))
        if (isExists) {
            return;
        }
        const pgName = productGroupList.find(p => Number(p.GroupID) === Number(currWG.current.ProductGroupID))?.GroupName;
        currWG.current.ProductGroup = pgName;
        if (!autoSendData.WorkingGroups || !Array.isArray(autoSendData.WorkingGroups)) {
            autoSendData.WorkingGroups = [];
        }
        autoSendData.WorkingGroups.push({ ...currWG.current });
        setAutoSendData({ ...autoSendData });
    }
    function onChangeInsertInAuto(value) {
        setPanelActive(!value);
        autoSendData.InsertInAutoSendList = value;
    }
    function removeWGfromList(pgID) {
        autoSendData.WorkingGroups = autoSendData.WorkingGroups.filter(w => Number(w.ProductGroupID) !== Number(pgID));
        setAutoSendData({ ...autoSendData });
    }
    function addWLtoList() {
        if (!currWL.current.ZoneID || currWL.current.ZoneID === "") {
            return;
        }
        const zoneName = zoneList.find(z => Number(z.Id) === Number(currWL.current.ZoneID))?.Name;
        currWL.current.ZoneName = zoneName;
        const isExists = autoSendData.WorkingLocations && Array.isArray(autoSendData.WorkingLocations) && autoSendData.WorkingLocations.some(w => Number(w.ZoneID) === Number(currWL.current.ZoneID))
        if (isExists) {
            return;
        }
        if (!autoSendData.WorkingLocations || !Array.isArray(autoSendData.WorkingLocations)) {
            autoSendData.WorkingLocations = [];
        }

        autoSendData.WorkingLocations.push({ ...currWL.current });
        currWL.current.ZoneID = null;
        setAutoSendData({ ...autoSendData });
    }
    function removeWLfromList(zoneID) {
        autoSendData.WorkingLocations = autoSendData.WorkingLocations.filter(w => Number(w.ZoneID) !== Number(zoneID));
        setAutoSendData({ ...autoSendData });
    }
    function updateData() {
        const onSuccess = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ثبت اطلاعات");
                return;
            }
            if (res.Data) {
                setErrorDialog(dispatch, "success", "ثبت اطلاعات");
                setAutoSendData(res.Data);
            }

        }
        autoSendData.StaffID = staffID;
        updateStaffAutoSendData(autoSendData, onSuccess);
    }
    useEffect(() => {
        dispatch(getAllProductMainGroups());
        const onGetData = (res) => {
            if (res.Data) {
                setAutoSendData(res.Data);
                setPanelActive(!res.Data.InsertInAutoSendList);
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "دریافت اطلاعات");
            }
        }
        getStaffAutoSendData(staffID, onGetData);
    }, [])
    return (
        <Fragment>
            {autoSendData === "PENDING" &&
                <Loader type="BallTrianlge" width={25} height={25} />
            }
            {autoSendData && autoSendData !== "PENDING" && Object.keys(autoSendData).length > 0 &&
                <Row className="mt-4 rowBorder">
                    <div className="rowTitle">
                        <input type="checkbox" className="form-check-input" name="InsertInAutoSendList" onChange={e => onChangeInsertInAuto(e.target.checked)} defaultChecked={autoSendData?.InsertInAutoSendList} />
                        &nbsp;
                        <label>درج در لیست جهت اعزام خودکار</label>
                    </div>
                    {panelIsActive &&
                        <div style={{ minHeight: "95%", minWidth: "95%", position: "absolute", zIndex: "100", backgroundColor: "#dccccc29", top: "5px" }}>&nbsp;</div>
                    }
                    <div className="mt-3 mb-2" style={{ color: "#023a40" }}>اعزام خودکار جهت انجام سرویس های</div>
                    <ul className="horizontalList" style={{ marginRight: "17px", borderBottom: "2px solid #023a40", color: "#2c2caf", paddingBottom: "5px" }}>
                        <li style={{ padding: " 0 3px 0 3px" }}>
                            <input type="checkbox" className="form-check-input" name="AutoSendForInstall" defaultChecked={autoSendData?.AutoSendForInstall} onChange={e => autoSendData.AutoSendForInstall = e.target.checked} />
                            &nbsp;
                            <label>نصب</label>
                        </li>
                        <li style={{ padding: " 0 3px 0 3px" }}>
                            <input type="checkbox" className="form-check-input" name="AutoSendForRepair" defaultChecked={autoSendData?.AutoSendForRepair} onChange={e => autoSendData.AutoSendForRepair = e.target.checked} />
                            &nbsp;
                            <label>تعمیر</label>
                        </li>
                        <li style={{ padding: " 0 3px 0 3px" }}>
                            <input type="checkbox" className="form-check-input" name="AutoSendForGuarantee" defaultChecked={autoSendData?.AutoSendForGuarantee} onChange={e => autoSendData.AutoSendForGuarantee = e.target.checked} />
                            &nbsp;
                            <label>گارانتی</label>
                        </li>
                        <li style={{ padding: " 0 3px 0 3px" }}>
                            <input type="checkbox" className="form-check-input" name="AutoSendForNonGuarantee" defaultChecked={autoSendData?.AutoSendForNonGuarantee} onChange={e => autoSendData.AutoSendForNonGuarantee = e.target.checked} />
                            &nbsp;
                            <label>غیرگارانتی</label>
                        </li>
                        <li style={{ padding: " 0 10px 0 3px" }}>
                            <input type="checkbox" className="form-check-input" name="AutoSendForEasy" defaultChecked={autoSendData?.AutoSendForEasy} onChange={e => autoSendData.AutoSendForEasy = e.target.checked} />
                            &nbsp;
                            <label>آسان</label>
                        </li>
                        <li style={{ padding: " 0 3px 0 3px" }}>
                            <input type="checkbox" className="form-check-input" name="AutoSendForNormal" defaultChecked={autoSendData?.AutoSendForNormal} onChange={e => autoSendData.AutoSendForNormal = e.target.checked} />
                            &nbsp;
                            <label>معمولی</label>
                        </li>
                        <li style={{ padding: " 0 3px 0 3px" }}>
                            <input type="checkbox" className="form-check-input" name="AutoSendForHard" defaultChecked={autoSendData?.AutoSendForHard} onChange={e => autoSendData.AutoSendForHard = e.target.checked} />
                            &nbsp;
                            <label>سخت</label>
                        </li>
                        <li style={{ padding: " 0 3px 0 3px" }}>
                            <input type="checkbox" className="form-check-input" name="AutoSendForVeryHard" defaultChecked={autoSendData?.AutoSendForVeryHard} onChange={e => autoSendData.AutoSendForVeryHard = e.target.checked} />
                            &nbsp;
                            <label>بسیار سخت</label>
                        </li>
                    </ul>
                    <Row>
                        <Col md={3} className="form-group">
                            <label>سطح مهارت: </label>
                            <select className="form-control" name="StaffSkillLevel" defaultValue={autoSendData?.StaffSkillLevel ?? ""} onChange={e => autoSendData.StaffSkillLevel = e.target.value}>
                                <option value="">انتخاب کنید</option>
                                <option value="A">A</option>
                                <option value="B">B</option>
                                <option value="C">C</option>
                            </select>
                        </Col>
                        <Col md={3} className="form-group" >
                            <label>ظرفیت پذیرش: </label>
                            <Form.Control type="number" name="StaffServiceCountCapacityPerDay" defaultValue={autoSendData?.StaffServiceCountCapacityPerDay ?? 0} onChange={e => autoSendData.StaffServiceCountCapacityPerDay = e.target.value} />
                        </Col>
                    </Row>
                    <Row className="rowBorder mt-4" style={{ margin: "auto", width: "99%" }} name="StaffWorkingProductGroups">
                        <div className="rowTitle" style={{ fontWeight: "normal", color: "purple" }}>
                            گروهبندی کالاهای تحت پوشش فعالیت
                        </div>
                        <Col md={5} className="row" style={{ height: "fit-content" }}>
                            <Col md={6} className="form-group">
                                <label>گروه اصلی</label>
                                {productMainGroupList === "PENDING" &&
                                    <div className="form-control"><Loader type="BallTriangle" color="#bb1370" width={25} height={25} /></div>}
                                {productMainGroupList && Array.isArray(productMainGroupList) &&
                                    <select className="form-control" name="CityID" onChange={e => loadPGList(e.target.value)}>
                                        <option value="">انتخاب کنید</option>
                                        {productMainGroupList.map((item, i) => <option key={i} value={item.MainGroupID}>{item.MainGroupName}</option>)}
                                    </select>
                                }
                            </Col>
                            <Col md={6} className="form-group">
                                <label>گروه کالا</label>
                                {productGroupList === "PENDING" &&
                                    <div className="form-control"><Loader type="BallTriangle" color="#bb1370" width={25} height={25} /></div>}
                                {productGroupList && Array.isArray(productGroupList) &&
                                    <select className="form-control" onChange={e => currWG.current.ProductGroupID = e.target.value}>
                                        <option value="">انتخاب کنید</option>
                                        {productGroupList.map((item, i) => <option key={i} value={item.GroupID}>{item.GroupName}</option>)}
                                    </select>
                                }
                            </Col>
                            <div>
                                <Button className="mt-1 group-Btn" onClick={addWGtoList}><PlusCircle size={18} />&nbsp; افزودن به لیست</Button>
                            </div>
                        </Col>
                        <Col md={5}>
                            <Table className="mt-4">
                                <thead>
                                    <tr>
                                        <th>ردیف</th>
                                        <th>گروه اصلی</th>
                                        <th>گروه کالا</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {autoSendData?.WorkingGroups && Array.isArray(autoSendData.WorkingGroups) &&
                                        autoSendData.WorkingGroups.map((wg, i) =>
                                            <tr key={i} className="resultTableRow">
                                                <td>{i + 1}</td>
                                                <td>{wg.MainGroup}</td>
                                                <td>{wg.ProductGroup}</td>
                                                <td><Trash size={18} className="rowBtn" color="red" onClick={() => removeWGfromList(wg.ProductGroupID)} /></td>
                                            </tr>)
                                    }
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row className="rowBorder mt-4" style={{ margin: "auto", width: "99%" }}>
                        <div className="rowTitle" style={{ fontWeight: "normal", color: "purple" }} name="StaffWorkingLocations">
                            مناطق جغرافیایی تحت پوشش فعالیت
                        </div>
                        <Col md={7} className="row">
                            <Col md={3} className="form-group">
                                <label>استان</label>
                                {provinceList === "PENDING" &&
                                    <div className="form-control">
                                        <Loader type="BallTriangle" color="#bb1370" width={25} height={25} />
                                    </div>
                                }
                                {provinceList && Array.isArray(provinceList) &&
                                    <select className="form-control" name="ProvinceID" onChange={e => loadCityList(e.target.value)}>
                                        <option value="">انتخاب کنید</option>
                                        {provinceList.map((item, i) => <option key={i} value={item.Id}>{item.Name}</option>)}
                                    </select>
                                }
                            </Col>
                            <Col md={3} className="form-group">
                                <label>شهر</label>
                                {cityList === "PENDING" &&
                                    <div className="form-control"><Loader type="BallTriangle" color="#bb1370" width={25} height={25} /></div>}
                                {cityList && Array.isArray(cityList) &&
                                    <select className="form-control" name="CityID" onChange={e => loadZoneList(e.target.value)}>
                                        <option value="">انتخاب کنید</option>
                                        {cityList.map((item, i) => <option key={i} value={item.Id}>{item.Name}</option>)}
                                    </select>
                                }
                            </Col>
                            <Col md={3} className="form-group">
                                <label>منطقه</label>
                                {zoneList === "PENDING" &&
                                    <div className="form-control"><Loader type="BallTriangle" color="#bb1370" width={25} height={25} /></div>}
                                {zoneList && Array.isArray(zoneList) &&
                                    <select className="form-control" name="ZoneID" onChange={e => currWL.current.ZoneID = e.target.value}>
                                        <option value="">انتخاب کنید</option>
                                        {zoneList.map((item, i) => <option key={i} value={item.Id}>{item.Name}</option>)}
                                    </select>
                                }
                            </Col>
                            <Col md={3} className="form-group" >
                                <label>بخش های مهم آدرس</label>
                                <Form.Control onChange={e => currWL.current.ImportantAddressParts = e.target.value} />
                            </Col>
                            <div>
                                <Button className="mt-1 group-Btn" onClick={addWLtoList}><PlusCircle size={18} />&nbsp; افزودن به لیست</Button>
                            </div>
                        </Col>
                        <Col md={5}>
                            <Table className="mt-4">
                                <thead>
                                    <tr>
                                        <th>استان</th>
                                        <th>شهر </th>
                                        <th>منطقه</th>
                                        <th>بخش های مهم آدرس</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {autoSendData?.WorkingLocations && Array.isArray(autoSendData.WorkingLocations) &&
                                        autoSendData.WorkingLocations.map((wl, i) =>
                                            <tr key={i} className="resultTableRow">
                                                <td>{wl.ProvinceName}</td>
                                                <td>{wl.CityName}</td>
                                                <td>{wl.ZoneName}</td>
                                                <td>{wl.ImportantAddressParts}</td>
                                                <td><Trash color="red" size={18} onClick={()=>removeWLfromList(wl.ZoneID)} /></td>
                                            </tr>)}
                                </tbody>
                            </Table>
                        </Col>
                        <label className="mt-4" style={{ color: "#8d4107" }}>
                            <ExclamationTriangleFill size={18} color="orange" />
                            لطفا بخش های مهم آدرس را با * از هم جدا کنید</label>
                    </Row>
                </Row>
            }
            <Button className="group-Btn-large mt-1" variant="success" onClick={updateData}><CheckLg size={18} />&nbsp;ثبت تغییرات</Button>
        </Fragment>
    )

}
export default AutoSendStaffSettings;